import React, { Component } from 'react';
import styles from './styles';
import { css } from 'aphrodite';

class Toggle extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isImperialSystem: props.isImperialSystem,
        }
    }

    handleChangeChk() {
        this.setState({isImperialSystem: !this.state.isImperialSystem}, ()=>{
            this.updateParentState();
        });
    }

    updateParentState() {
        this.props.onSystemChange(this.state.isImperialSystem);
    }

    render() {
        const { metricLabel, imperialLabel } = this.props;
        return(
            <div className={css(styles.container)}>
                <label className={css(styles.col, styles.label, !this.state.isImperialSystem && styles.bold)} onClick={()=>this.setState({isImperialSystem: false}, ()=>{
                    this.updateParentState();
                })}>{metricLabel}</label>
                <div className={css(styles.col, styles.switch)}>
                    <input
                        className={css(styles.input)}
                        id={`react-switch-new`}
                        type="checkbox"
                        checked={this.state.isImperialSystem}
                        onChange={() => this.handleChangeChk()}
                    />
                    <label
                        className={css(styles.switchLabel)}
                        htmlFor={`react-switch-new`}
                    >
                        <span className={css(styles.switchButton, this.state.isImperialSystem && styles.active)}/>
                    </label>
                </div>
                <label className={css(styles.col, styles.label, this.state.isImperialSystem && styles.bold)} onClick={()=>this.setState({isImperialSystem: true}, ()=>{
                    this.updateParentState();
                })}>{imperialLabel}</label>
            </div>
        );
    }
}

export default Toggle;